export default "assets/images/6a580287dea82c2fb9b214321a375145.png";